/* eslint-disable react/jsx-props-no-spreading */
import { Field, type FieldProps } from 'formik';
import { type OptionalTestId } from '@common/components/controls/TestId';
import Textarea, { type TextareaProps } from '@common/components/controls/Textarea';

function TextareaField(props: OptionalTestId<TextareaProps>) {
  const {
    name,
    'data-testid': testId,
    ...rest
  } = props;
  return (
    <Field name={name}>
      {({ field, field: { onBlur, onChange }, meta: { touched, error } }: FieldProps) => (
        <Textarea
          data-testid={testId || `${name}-textarea`} // NOSONAR:S6606 - Empty testId should use default
          {...rest}
          {...field}
          onChange={(event) => {
            rest?.onChange?.(event);
            onChange(event);
          }}
          onBlur={(event) => {
            rest?.onBlur?.(event);
            onBlur(event);
          }}
          error={error}
          touched={touched}
        />
      )}
    </Field>
  );
}

export default TextareaField;
